export const SUPPORTED_LANGS = ["en", "ja", "vi"]

export const normalizeLang = (value) => {
  if (!value) return null

  const normalized = String(value).trim().replaceAll("_", "-").toLowerCase()
  if (!normalized) return null

  const base = normalized.split("-")[0]
  return SUPPORTED_LANGS.includes(base) ? base : null
}

